module.exports = __webpack_public_path__ + "img/24.8ea6ab40.jpg";